import { toast } from 'sonner';
import { useWorkflowStore } from '../store/workflowStore';
import useCanvasNavStore from '../store/canvasNavStore';

/**
 * "Ir al nodo de origen" — desde un clip del timeline al nodo del canvas
 * que lo generó. Sólo navegación: selecciona el nodo y lo hace parpadear
 * 2 s; el centrado lo hace el canvas cuando se monta la vista.
 *
 * No toca el grafo ni guarda nada.
 */
export const goToSourceNode = (nodeId) => {
  if (!nodeId) return false;
  const node = useWorkflowStore.getState().nodes.find((n) => n.id === nodeId);
  if (!node) {
    toast.error('Ese nodo ya no existe en el canvas.', { position: 'bottom-right' });
    return false;
  }
  useWorkflowStore.getState().setSelectedNode(node);
  useCanvasNavStore.getState().flash(nodeId);
  useCanvasNavStore.getState().requestFocus(nodeId);
  const number = String(nodeId).replace(/\D/g, '');
  toast.success(`Te llevo al nodo #${number}${node.data?.name ? ` · ${node.data.name}` : ''}`,
                { position: 'bottom-right' });
  return true;
};

export default goToSourceNode;
